export var OptionChainScreens;
(function (OptionChainScreens) {
    OptionChainScreens["ALL"] = "all";
    OptionChainScreens["CHART"] = "chart";
    OptionChainScreens["CHAIN"] = "chain";
    OptionChainScreens["CHANGE"] = "change";
    OptionChainScreens["PAIN"] = "pain";
})(OptionChainScreens || (OptionChainScreens = {}));
export var OptionGraphLoaderTypes;
(function (OptionGraphLoaderTypes) {
    OptionGraphLoaderTypes["OI_CHART_LOADER"] = "OIChartLoader";
    OptionGraphLoaderTypes["OI_CHANGE_LOADER"] = "OIChangeLoader";
    OptionGraphLoaderTypes["OPTION_PAIN_LOADER"] = "OptionPainLoader";
    OptionGraphLoaderTypes["OPTION_MAIN_LOADER"] = "OptionMainLoader";
})(OptionGraphLoaderTypes || (OptionGraphLoaderTypes = {}));
export var OptionGraphErrorTypes;
(function (OptionGraphErrorTypes) {
    OptionGraphErrorTypes["OI_CHART_ERROR"] = "OIChartErrorData";
    OptionGraphErrorTypes["OI_CHANGE_ERROR"] = "OIChangeErrorData";
    OptionGraphErrorTypes["OPTION_PAIN_ERROR"] = "OptionPainErrorData";
})(OptionGraphErrorTypes || (OptionGraphErrorTypes = {}));
